module.exports = __webpack_public_path__ + "img/suggestions.ca5100dd.svg";